import type { ProductsState } from 'src/redux/products/types';
import { getViewProductsForDayLabel, MODAL_CONTROLS_CLOSE, NO_MATCHING_PRODUCTS } from './copy';

/**
 * The label shown on the "view results" CTA of a filter drawer. Shared by the
 * full listings-controls drawer and the per-facet drawer so both stay in sync.
 */
export const getViewResultsButtonText = (
  products: Pick<ProductsState, 'error' | 'totalProducts'>,
  guaranteedArrivalDayName?: string,
): string => {
  if (products.error) {
    return MODAL_CONTROLS_CLOSE;
  }

  if (products.totalProducts === 0) {
    return NO_MATCHING_PRODUCTS;
  }

  if (guaranteedArrivalDayName) {
    return getViewProductsForDayLabel(products.totalProducts, guaranteedArrivalDayName);
  }

  return `View ${products.totalProducts} products`;
};
